import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import { useParams } from "react-router-dom";
import { MapInteractionCSS } from "react-map-interaction";
import { useViewport } from "../../Components/ViewportProvider";

// State
import { setLoading } from "../../State/slices/session-slice";
// Reports
import CareAct from "../../Reports/CareAct";
// Components
import Page from "../../Components/Page";
import NoDataBox from "../../Components/NoDataBox";
// Utils
import { getReport, ReportResponseBody } from "@intelligentlilli/api-layer";
import { useAppDispatch, useAppSelector } from "State/hooks";
import classNames from "classnames";

function PdfPreviewV2() {
  // Get the resident from redux
  const server = useAppSelector((state) => state.session.server);
  const dispatch = useAppDispatch();
  // Dimensions
  const { width } = useViewport();

  // Get the report ID from the parameters
  const { id } = useParams();
  // Local state
  const [data, setData] = useState<ReportResponseBody | undefined>();
  const [error, setError] = useState(false);

  const reportSizeBreakpoint = 1150;

  // Get the behaviour data for the hub
  useEffect(() => {
    if (id) {
      dispatch(setLoading(true));
      getReport(server, id, "web")
        .then((res) => {
          dispatch(setLoading(false));
          if (res.ok) {
            setData(res.data);
          } else {
            setError(true);
          }
        })
        .catch(() => {
          dispatch(setLoading(false));
          setError(true);
        });
    }
  }, [id, server, dispatch]);

  return (
    <Page className={styles.page}>
      {data && width > reportSizeBreakpoint && !error && (
        <div className={classNames(styles.report, styles.align_center)}>
          <CareAct reportData={data} isPdf={false} />
        </div>
      )}
      {(error || !data) && (
        <div className={styles.error_fetching_report}>
          <NoDataBox
            title={"Error fetching report"}
            text={"Check back later"}
          />
        </div>
      )}
      {data && width <= reportSizeBreakpoint && !error && (
        <div className={styles.report}>
          <MapInteractionCSS
            defaultValue={{ scale: 0.5, translation: { x: 0, y: 0 } }}
            translationBounds={{
              xMin: -700,
              xMax: 300,
              yMin: -10000, // This is an arbitrary translation bound. It may be we need to adjust it for longer reports
              yMax: 100,
            }}
            minScale={0.3}
            maxScale={1}
          >
            <CareAct reportData={data} isPdf={false} />
          </MapInteractionCSS>
        </div>
      )}
    </Page>
  );
}

export default PdfPreviewV2;
